module.exports = __webpack_public_path__ + "media/images/phone/app-download-banner-title-a0d8e276890e64a35e277bbdb42fc2f2.png";